"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmationModal = exports.AlertModal = exports.Modal = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icon = _interopRequireDefault(require("./icon"));

var _button = _interopRequireDefault(require("./button"));

require("../css/modal.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Modal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Modal, _React$Component);

  _createClass(Modal, null, [{
    key: "hasScroll",
    value: function hasScroll() {
      var scrollHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.body.clientHeight, document.documentElement.clientHeight);
      return scrollHeight > window.innerHeight;
    }
  }, {
    key: "toFlexAlignment",
    value: function toFlexAlignment(align) {
      switch (align) {
        case 'left':
          return 'flex-start';

        case 'right':
          return 'flex-end';

        default:
          return align;
      }
    }
  }]);

  function Modal(props) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Modal).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "closeModal", function () {
      _this.props.onClose();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleKeyDownEvent", function (event) {
      if (_this.props.show && event.keyCode === _this.ESCAPE_CODE) {
        _this.closeModal();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleOverlayClick", function (event) {
      if (event.target === _this.overlayNode) {
        event.stopPropagation();

        if (_this.props.dismissOnOverlayClick) {
          _this.props.onClose();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleOverlayKeyDown", function (event) {
      if (event.target === _this.overlayNode) {
        event.stopPropagation();
      }
    });

    _this.ESCAPE_CODE = 27;
    _this.HTML_BODY_CLASS = 'vn-modal-html-body';
    return _this;
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('keydown', this.handleKeyDownEvent);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.show !== this.props.show) {
        this.updateBody();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeyDownEvent);
      this.refreshBody();
    }
  }, {
    key: "refreshBody",
    value: function refreshBody() {
      document.body.classList.remove(this.HTML_BODY_CLASS);
      document.body.style['padding-right'] = null;
    }
  }, {
    key: "updateBody",
    value: function updateBody() {
      /* We need to hide the scroll from html body and
         also give it a padding-right to compensate the space of the scroll
      */
      if (Modal.hasScroll()) {
        var scrollWidth = Math.max(document.body.scrollWidth, document.documentElement.scrollWidth, document.body.offsetWidth, document.documentElement.offsetWidth, document.body.clientWidth, document.documentElement.clientWidth);
        var compensatePadding = window.innerWidth - scrollWidth;
        if (this.props.show) {
          document.body.classList.add(this.HTML_BODY_CLASS);
          document.body.style['padding-right'] = "".concat(compensatePadding, "px");
        } else {
          document.body.classList.remove(this.HTML_BODY_CLASS);
          document.body.style['padding-right'] = null;
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      if (!this.props.show) {
        return _react.default.createElement("div", null);
      }

      var _this$props = this.props,
          align = _this$props.align,
          children = _this$props.children,
          dismissOnOverlayClick = _this$props.dismissOnOverlayClick,
          footer = _this$props.footer,
          i18n = _this$props.i18n,
          size = _this$props.size,
          title = _this$props.title,
          show = _this$props.show,
          onClose = _this$props.onClose,
          remainingProps = _objectWithoutProperties(_this$props, ["align", "children", "dismissOnOverlayClick", "footer", "i18n", "size", "title", "show", "onClose"]);

      var alignStyle = {
        alignSelf: Modal.toFlexAlignment(align),
        textAlign: align
      };
      return _react.default.createElement("div", _extends({}, remainingProps, {
        className: "vn-modal",
        onClick: this.handleOverlayClick,
        onKeyDown: this.handleOverlayKeyDown,
        ref: function ref(node) {
          _this2.overlayNode = node;
        },
        role: "none"
      }), _react.default.createElement("div", {
        className: "vn-modal__dialog vn-modal__dialog--".concat(size)
      }, _react.default.createElement("div", {
        className: "vn-modal__content"
      }, title && _react.default.createElement("div", {
        className: "vn-modal__header",
        style: alignStyle
      }, _react.default.createElement("h4", null, title)), _react.default.createElement("button", {
        className: "vn-modal__close",
        onClick: this.closeModal,
        ref: function ref(node) {
          _this2.closeLink = node;
        },
        title: i18n.close,
        type: "button"
      }, _react.default.createElement(_icon.default, {
        name: "close"
      })), _react.default.createElement("div", {
        className: "vn-modal__body",
        style: alignStyle
      }, children), footer && _react.default.createElement("div", {
        className: "vn-modal__footer",
        style: alignStyle
      }, footer))));
    }
  }]);

  return Modal;
}(_react.default.Component);

exports.Modal = Modal;
Modal.propTypes = {
  align: _propTypes.default.oneOf(['left', 'right', 'center']),
  children: _propTypes.default.node,
  dismissOnOverlayClick: _propTypes.default.bool,
  footer: _propTypes.default.element,
  i18n: _propTypes.default.shape({
    close: _propTypes.default.string.isRequired
  }),
  onClose: _propTypes.default.func,
  show: _propTypes.default.bool,
  size: _propTypes.default.oneOf(['sm', 'md', 'lg', 'xl']),
  title: _propTypes.default.string
};
Modal.defaultProps = {
  align: 'left',
  children: null,
  dismissOnOverlayClick: true,
  footer: null,
  i18n: {
    close: 'Close'
  },
  onClose: function onClose() {},
  show: false,
  size: 'md',
  title: null
};
/*----------------------------------------------------------------------------------------------*/

var AlertModal = function AlertModal(props) {
  return _react.default.createElement(Modal, _extends({}, props, {
    align: "center"
  }));
};

exports.AlertModal = AlertModal;
AlertModal.defaultProps = {
  size: 'sm'
};

var ConfirmationModal = function ConfirmationModal(_ref) {
  var children = _ref.children,
      closeButtonLabel = _ref.closeButtonLabel,
      confirmButtonLabel = _ref.confirmButtonLabel,
      onClose = _ref.onClose,
      onConfirm = _ref.onConfirm,
      size = _ref.size,
      show = _ref.show,
      title = _ref.title,
      others = _objectWithoutProperties(_ref, ["children", "closeButtonLabel", "confirmButtonLabel", "onClose", "onConfirm", "size", "show", "title"]);

  var closeModal = function closeModal() {
    onClose();
  };

  var footer = _react.default.createElement("div", {
    className: "vn-button-group--responsive"
  }, _react.default.createElement(_button.default, {
    onClick: onConfirm
  }, confirmButtonLabel), _react.default.createElement(_button.default, {
    onClick: closeModal,
    appearance: "secondary",
    autoFocus: true
  }, closeButtonLabel));

  return _react.default.createElement(Modal, _extends({}, others, {
    footer: footer,
    onClose: closeModal,
    show: show,
    size: size,
    title: title
  }), children);
};

exports.ConfirmationModal = ConfirmationModal;
ConfirmationModal.propTypes = {
  align: _propTypes.default.oneOf(['left', 'right', 'center']),
  children: _propTypes.default.node,
  closeButtonLabel: _propTypes.default.string,
  confirmButtonLabel: _propTypes.default.string,
  onClose: _propTypes.default.func,
  onConfirm: _propTypes.default.func,
  show: _propTypes.default.bool,
  size: _propTypes.default.oneOf(['sm', 'md', 'lg', 'xl']),
  title: _propTypes.default.string
};
ConfirmationModal.defaultProps = {
  align: 'center',
  children: Modal.defaultProps.children,
  closeButtonLabel: 'Close',
  confirmButtonLabel: 'OK',
  onClose: Modal.defaultProps.onClose,
  onConfirm: undefined,
  show: false,
  size: Modal.defaultProps.size,
  title: Modal.defaultProps.title
};
Modal.displayName = 'Modal';
AlertModal.displayName = 'AlertModal';
ConfirmationModal.displayName = 'ConfirmationModal';
var _default = Modal;
exports.default = _default;